'use client';

import { OverlayArrow, Tooltip } from 'react-aria-components';
import { InfoIcon } from '@fagmobler/ui';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import { TooltipTipBottom } from '@/cataloguePages/productPageWithVariants/components/tooltip/TooltipBottom';
import { PropsWithChildren } from 'react';

export type TooltipPlacement =
  | 'bottom'
  | 'bottom left'
  | 'bottom right'
  | 'top'
  | 'top left'
  | 'top right';

type Props = PropsWithChildren & {
  size?: 'small' | 'large';
  placement?: TooltipPlacement;
};

export const TooltipBase = ({
  size = 'small',
  placement = 'top',
  children,
}: Props) => {
  return (
    <Tooltip
      offset={9}
      placement={placement}
      className={twMerge(
        clsx(
          'rounded bg-neutral-80 text-neutral-0 flex flex-col gap-1 p-3 tooltip !z-30',
          {
            'w-[156px]': size === 'small',
            'w-[272px]': size === 'large',
          }
        )
      )}
    >
      <div className="flex gap-1 items-center body-xs">{children}</div>
      <OverlayArrow className="group">
        <TooltipTipBottom
          className={twMerge(
            clsx(
              'text-neutral-80 w-[20px] h-[9px] relative top-[-1px] z-10',
              "group-data-[placement='bottom']:rotate-180 group-data-[placement='bottom']:top-[1px]",
              "group-data-[placement='left']:rotate-270 group-data-[placement='left']:right-[6px]",
              "group-data-[placement='right']:rotate-90 group-data-[placement='right']:left-[6px]"
            )
          )}
        />
      </OverlayArrow>
    </Tooltip>
  );
};
